import DOMPurify from "dompurify";
import componentSlider from "../../common/componentSlider.js";

function toggleSlidePlay(slide, button, playing, $slider) {
  if (!slide) return;

  const videoEls = slide.querySelectorAll(".js-background-video-media");

  if (!playing) {
    button.classList.add("video-button--playing");

    if ($slider) {
      $slider.slick("slickPlay");
    }

    if (videoEls.length > 0) {
      videoEls.forEach((video) => video.play());
    }
  } else {
    button.classList.remove("video-button--playing");

    if ($slider) {
      $slider.slick("slickPause");
    }

    if (videoEls.length > 0) {
      videoEls.forEach((video) => video.pause());
    }
  }
}

export default () => {
  document.querySelectorAll(".js-text-over-carousel").forEach((el) => {
    if (document.body.classList.contains("is-page-editor")) {
      return;
    }

    if (el.classList.contains("js-text-over-carousel-animated")) {
      el.classList.add("is-open");

      setTimeout(() => {
        el.classList.add("is-animated");
      }, 2000);
    }

    const slides = el.querySelectorAll(".js-slide-container > *");

    const config = {
      dots: true,
      infinite: true,
      adaptiveHeight: false,
      speed: 850,
      slidesToShow: 1,
      slidesToScroll: 1,
      accessibility: true,
      autoplay: true,
      autoplaySpeed: 10000,
      responsive: [
        {
          breakpoint: 680,
          settings: {
            verticalSwiping: false,
          },
        },
      ],
      verticalSwiping: true,
      fade: true,
    };

    const captionContainerEl = el.querySelector(
      ".js-text-over-carousel__caption-container",
    );
    const playButton = el.querySelector(".js-text-over-carousel__play-button");
    let playing = true;

    slides.forEach((slide, index) => {
      slide.classList.add("text-over-media--gate");
      const overlay = slide.querySelector(".js-text-over-media__overlay");
      overlay.classList.remove("gate-style");

      const newCaption = document.createElement("div");
      newCaption.classList.add("text-over-media__caption", "js-slide-caption");
      newCaption.id = `text-over-media__caption-${index}`;

      const caption = slide.querySelector(".js-text-over-media__caption");
      if (caption) {
        newCaption.innerHTML = DOMPurify.sanitize(caption.innerHTML);
      }

      captionContainerEl.appendChild(newCaption);

      const figure = slide.querySelector("figure");
      if (figure) {
        figure.setAttribute("aria-labelledby", newCaption.id);
      }
    });

    const captions = el.querySelectorAll(".js-slide-caption");

    if (captions.length > 0) {
      captions[0].classList.add("is-active");
    }

    if (slides.length < 2) {
      playButton.addEventListener("click", (e) => {
        toggleSlidePlay(slides[0], playButton, playing);
        playing = !playing;
      });

      return;
    }

    if (document.dir === "rtl" || el.parentElement.dir === "rtl") {
      config.rtl = true;
      el.dataset.isRtl = "true";
    }

    const { $slider } = componentSlider(el, config);

    $slider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        captionContainerEl
          .querySelector(".is-active")
          ?.classList.remove("is-active");
        captions[nextSlide].classList.add("is-active");

        const videoEls = slides[nextSlide].querySelectorAll(
          ".js-background-video-media",
        );

        if (videoEls.length > 0) {
          videoEls.forEach((video) => {
            if (playing) {
              video.play();
            } else {
              video.pause();
            }
          });
        }
      },
    );

    playButton.addEventListener("click", (e) => {
      const currentSlide = $slider.slick("slickCurrentSlide");
      toggleSlidePlay(slides[currentSlide], playButton, playing, $slider);
      playing = !playing;
    });
  });
};
